import safeSportWithColorLogo from '../../img/SafeSportwithColor.jpg'
import ASRVPcard from './ASRVP-Card';
import { cardStatusType, textStatusType } from '../shared/helpers';
import { useEffect, useState } from 'react';
import useManageApi from '../../hooks/useManageApi';

const ASRVPTraining = (props) => {
    const { registerWithSafeSport, loading: registerWithSafeSportLoading } = useManageApi();
    const [textBSColor, setTextBSColor] = useState();
    const [cardText, setCardText] = useState();

    useEffect(() => {
        if (props?.model?.trainedActivity?.statusColor) {
            setTextBSColor(textStatusType(props?.model?.trainedActivity?.statusColor));
        }
        if (props?.model?.isYouth) {
            setCardText("U.S. Center for SafeSport training will be required once you turn 18 if you have regular contact with minor athletes (bowling in a league with members 17 or under)");
        } else {
            setCardText("If you have regular contact with minor athletes (bowling in a league with members 17 or under) you must take U.S. Center for SafeSport training each season");
        }
    }, [props]);

    function handleRegisterWithSafeSport() {
        props.setValidationErrors(null);
        registerWithSafeSport({
            onError: (errors) => {
                props.setValidationErrors(errors);
                // Scroll to the top of the page
                window.scrollTo(0, 0);
            }
        }
        ).then((result) => {
            if (result && result.data) {
                props.setIsRedirecting(true);
                window.location.href = result.data;
            }
        });
    }


    return (
        <>
            <ASRVPcard
                text={cardText}
                image={<img className="asrvp-safesport-color-logo asrvp-logo" src={safeSportWithColorLogo} atl="U.S. Center for SafeSport Training" />}
                imageText={"U.S. Center for SafeSport Training"}
                statusText={
                    <div>
                        {!props?.model?.trainedActivity?.showYouthMessage &&
                            <div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.trainingMessageLine1}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.trainingMessageLine2}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.trainingMessageLine3}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.trainingMessageLine4}
                                </div>
                            </div>}
                        {props?.model?.trainedActivity?.showYouthMessage &&
                            <div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.youthMessageLine1}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.youthMessageLine2}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.trainedActivity?.youthMessageLine3}
                                </div>
                            </div>}
                    </div>

                }
                cardStatusType={cardStatusType(textBSColor)}
            >
                {/* Children */}

                {/* Special handling of Register With SafeSport */}
                {props.safeSportTrainingAvailable !== true &&
                    <div className="text-center" style={{ paddingLeft: "15%", paddingRight: "15%", paddingBottom: "2%" }}>
                        <a data-bs-toggle="modal" role="button" data-bs-target="#ssTurnedOffModal" className={"btn btn-block " + props?.model?.trainedActivity?.buttonStatus}> 
                            {props?.model?.trainedActivity?.buttonText}
                        </a>
                    </div>
                }
                {props.safeSportTrainingAvailable === true &&
                    <>
                        {props?.model?.trainedActivity?.showTrainingButton
                            && props?.model?.trainedActivity?.trainingActivityUrl === "/AthleteSafetyPortal/AthleteSafetyRVP/RegisterWithSafeSport"
                            && <button type="button" onClick={handleRegisterWithSafeSport} disabled={registerWithSafeSportLoading} className={'btn mt-3 ' + props?.model?.trainedActivity?.buttonStatus}>{props?.model?.trainedActivity?.buttonText}</button>}

                        {props?.model?.trainedActivity?.showTrainingButton
                            && props?.model?.trainedActivity?.trainingActivityUrl !== "/AthleteSafetyPortal/AthleteSafetyRVP/RegisterWithSafeSport"
                            && <a href={props?.model?.trainedActivity?.trainingActivityUrl} className={'btn mt-3 ' + props?.model?.trainedActivity?.buttonStatus}>{props?.model?.trainedActivity?.buttonText}</a>}
                    </>
                }

            </ASRVPcard>

            <div className="modal fade" id="ssTurnedOffModal" tabIndex="-1" role="dialog" aria-labelledby="ssTurnedOffLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title fs-5" id="rvpRolesModalLabel">SafeSport Training</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="text-left">
                                <label>SafeSport Training down for routine maintenance. Please check back later.</label>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>


    );
}

export default ASRVPTraining;